var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2312 1.10052C14.8732 0.742536 14.2928 0.742536 13.9348 1.10052L1.10149 13.9338C0.929585 14.1058 0.833008 14.3389 0.833008 14.582V18.2487C0.833008 18.755 1.24341 19.1654 1.74967 19.1654H5.41634C5.65946 19.1654 5.89261 19.0688 6.06452 18.8969L18.8979 6.06355C19.2558 5.70556 19.2558 5.12516 18.8979 4.76718L15.2312 1.10052ZM15.4997 6.869L13.1294 4.4987L14.583 3.04506L16.9533 5.41536L15.4997 6.869ZM11.833 5.79506L14.2033 8.16536L6.33301 16.0357L3.9627 13.6654L11.833 5.79506ZM2.66634 14.9617L5.03664 17.332H2.66634V14.9617Z",
    fill: "#5D627C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9163 17.332C10.4101 17.332 9.99967 17.7424 9.99967 18.2487C9.99967 18.755 10.4101 19.1654 10.9163 19.1654H18.2497C18.7559 19.1654 19.1663 18.755 19.1663 18.2487C19.1663 17.7424 18.7559 17.332 18.2497 17.332H10.9163Z",
    fill: "#5D627C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.6847de84f54d3e3f9c60edfaf094a371.svg";
export { ForwardRef as ReactComponent };